export const Column = `<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M7 4V28" stroke="currentColor" stroke-width="2"/>
<path d="M25 4V28" stroke="currentColor" stroke-width="2"/>
<rect x="13" y="5" width="6" height="22" rx="1" stroke="currentColor" stroke-width="2"/>
</svg>`;
